"use client";

import { useQuery } from "@tanstack/react-query";
import { publicSettingsQuery } from "./art-catalogue-enabled";

/**
 * Whether map prints are on sale — the `mapsEnabled` row thrown from
 * admin → Nastavitve. Hides the menu entry here; /zemljevid answers 404 on the
 * server and the API refuses preview, search and add-map (403 MAPS_DISABLED).
 * FALSE while loading or on error, like the other switches.
 */
export function useMapsEnabled(): boolean {
  const { data } = useQuery(publicSettingsQuery);
  return data?.mapsEnabled === true;
}
